<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="所属门店：">
          <el-select v-model="formInline.belongStoreKeyId" placeholder="请选择门店" clearable size="small"
            @change="inputChange">
            <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="顾客类型：">
          <el-select v-model="formInline.customerType" placeholder="请选择顾客类型" filterable size="small"
            @change="inputChange">
            <el-option v-for="item in customerTypeList" :label="item.value" :value="item.keyId"
              :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档案编号：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.customerNo"
            placeholder="请输入档案编号"></el-input>
        </el-form-item>
        <el-form-item label="顾客姓名：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.name"
            placeholder="请输入顾客姓名"></el-input>
        </el-form-item>
        <el-form-item label="电话：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.phone"
            placeholder="请输入电话"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button v-if="this.$checkBtnPermission('/customer/index', 'viewPage')" size="small" type="primary"
            class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
          <el-button v-if="this.$checkBtnPermission('/customer/index', 'reset')" size="small" icon="el-icon-refresh"
            @click="clearAll">重置</el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <el-button v-if="this.$checkBtnPermission('/customer/index', 'create')" size="small" type="primary"
            class="el-icon-plus" @click="handleEdit()">新增
          </el-button>
          <my-column-filter v-if="this.$checkBtnPermission('/customer/index', 'myFilter')" :listColumns="listColumns"
            @hidePop="getCheckBox"></my-column-filter>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading"
        @handle-command="handleCommand" @rowClick="handleRowClick" border>
        <el-table-column align="center" slot="gender" label="性别" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.gender == 1" class="one_1">
              {{ formatterFre(scope.row.gender) }}</span>
            <span v-if="scope.row.gender == 0" class="one_2">
              {{ formatterFre(scope.row.gender) }}</span>
          </template>
        </el-table-column>
      </STable>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </topTab>
    <!-- 编辑 -->
    <edit ref="edit"></edit>
  </div>
</template>

<script>
import {
  getCustomerInfoPageList,
  deleteCustomerInfo,
} from "@/api/baseDataApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import edit from "./edit";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "顾客列表",
        },
      ],
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      storeList: [],
      selectionList: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        name: "",
        phone: "",
        belongStoreKeyId: "",
        customerType: 0,
        customerNo: "",
      },
      columnsData: [], //显示列
      listColumns: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          prop: "name",
          label: "顾客姓名",
          align: "center",
          isKeep: true,
          minWidth: "120",
        },
        {
          prop: "customerTypeStr",
          label: "顾客类型",
          align: "center",
          isKeep: true,
          minWidth: "120",
        },
        {
          prop: "customerNo",
          label: "档案编号",
          align: "center",
          isKeep: true,
          minWidth: "120",
        },
        {
          prop: "phone",
          label: "联系电话",
          align: "center",
          minWidth: "120",
        },
        {
          slot: "gender",
          label: "性别",
          minWidth: "80",
        },
        {
          prop: "age",
          label: "年龄",
          align: "center",
          minWidth: "80",
        },
        {
          prop: "belongStoreName",
          label: "所属门店",
          align: "center",
          minWidth: "80",
        },
        {
          prop: "creator",
          label: "创建人",
          align: "center",
          minWidth: "80",
        },
        {
          prop: "createTime",
          label: "创建时间",
          align: "center",
          minWidth: "150",
        },
        {
          prop: "editor",
          label: "维护人",
          align: "center",
          minWidth: "80",
        },
        {
          prop: "updateTime",
          label: "维护时间",
          align: "center",
          minWidth: "150",
        },
        // {
        //   operation: true,
        //   isKeep: true,
        //   label: "操作",
        //   btnGroup: [
        //     {
        //       icon: "el-icon-delete",
        //       name: "删除",
        //       type: "4",
        //       btnType: "danger",
        //     },
        //   ],
        // },
      ],
      customerTypeList: [],
    };
  },
  // 注册组件
  components: {
    edit,
  },
  created() {
    this.GetOrgInfoListByConfig();
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.getListData();
    this.GetEnumConfigListByCode();
  },
  computed: {},
  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    // 性别
    formatterFre(gender) {
      return gender == 1 ? "男" : gender == 0 ? "女" : "";
    },
    changePages() { },
    handleCommand(command) {
      // 1编辑
      switch (command.command) {
        case "4":
          this.deleteCustomer(command.rowData);
          break;
        default:
          console.log(command);
      }
    },
    // 获取所属门店
    GetOrgInfoListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = [];
            if (res.code == 1) {
              res.data.forEach((item) => {
                this.storeList.push({
                  keyId: item.keyId,
                  value: item.name + '【' + item.remark2 + '】',
                });
              });
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    // 获取顾客类型
    GetEnumConfigListByCode() {
      const paramer = {
        code: "CustomerType",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.customerTypeList = [];
            res.data.forEach((item) => {
              this.customerTypeList.push({
                keyId: parseInt(item.code),
                value: item.name,
              });
            });
            this.customerTypeList.unshift({
              keyId: 0,
              value: "全部",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取顾客类型信息失败!");
        });
    },
    // 单击行数据
    handleRowClick(row) {
      this.$refs.edit.editShow(row);
    },
    //显示编辑界面
    handleEdit(row) {
      this.$refs.edit.editShow(row);
    },
    // 删除
    deleteCustomer(row) {
      this.$confirm("确定要删除顾客【" + row.name + "】吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let parmter = {
          keyId: row.keyId,
        };
        deleteCustomerInfo(parmter)
          .then((res) => {
            if (res.code === 1) {
              this.$message({
                type: "success",
                message: "已删除!",
              });
              this.getListData();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("删除失败，请稍后再试！");
          });
      });
    },
    // 获取列表
    getListData() {
      this.loading = true;
      getCustomerInfoPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 重置
    clearAll() {
      this.$data.formInline = this.$options.data.call(this).formInline;
      this.search();
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
  },
};
</script>

<style scoped>
.one_1 {
  padding: 2px 20px;
  background: #e6f7ff;
  border: 1px solid #6acaf3;
  color: #56bbfd;
  border-radius: 2px;
}

.one_2 {
  padding: 2px 20px;
  background: #fcd4ff;
  border: 1px solid #dfbce2;
  color: #ea7cff;
  border-radius: 2px;
}
</style>